const audiences = [
  {
    icon: 'ri-user-star-line',
    title: 'Новые руководители',
    desc: 'Для специалистов, недавно назначенных на управленческие должности. Помогаем освоить новую роль: от ответственности за свой результат — к ответственности за результат команды.',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Руководители среднего звена',
    desc: 'Для менеджеров, которым необходимо повысить эффективность управления командой, улучшить постановку задач, делегирование и контроль.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Руководители отделов продаж',
    desc: 'Для РОПов и коммерческих руководителей. Развитие управленческих навыков в контексте управления продажами и работы с командой.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Топ-менеджеры',
    desc: 'Для руководителей, работающих с масштабированием, стратегическими изменениями и развитием управленческой культуры компании.',
  },
  {
    icon: 'ri-group-line',
    title: 'Управленческие команды',
    desc: 'Для компаний, которым необходимо сформировать единый управленческий подход, общий язык и согласованные методы работы.',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Кадровый резерв',
    desc: 'Для сотрудников, которых компания планирует подготовить к руководящим должностям. Системное развитие до выхода на управленческую позицию.',
  },
];

export default function TargetAudienceSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Для кого предназначено обучение
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Программы развития менеджмента и лидерства адаптируются под уровень руководителей и конкретные задачи компании.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {audiences.map((aud, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-50 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-100 transition-colors">
                <i className={`${aud.icon} text-xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{aud.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{aud.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}